import React, { useEffect, useState } from 'react'

import { toast } from 'react-toastify'
import { creditCardTypeAsset } from '../../_helpers/utils'
import {bankService} from '../../_services/bank.service'


import AlertBox from '../AlertBox'

import { subscriptionService } from '../../_services'



export const Card = ({ 
    data, 
    setRefreshKey, 
    primaryId,
    subscriptionInfo,
    setSubscriptionInfo,
    selectedAction = undefined, 
    selectedStyle = undefined, 
    selectText = undefined,
    selectedText = undefined, 
    selectedViewStyle = undefined, 
    selectButtonStyle = undefined
 }) => {
    const [alert, setAlert] = useState(false)
    const [primaryRequest, setPrimaryRequest] = useState(false)

    const [selected, setSelected] = useState(data.id == primaryId)

    useEffect(() => {
        setSelected(data.id == primaryId)
    }, [data, primaryId])


    const handleDelete = async () => {
        try {
            const res = await bankService.deleteCard(data.id)
            if (res.status) {
                toast.success(res.message)
                setRefreshKey((e) => e + 1)
                setAlert(false)
            } else toast.error(res.message)
        } catch (error) {
            toast.error('Something went wrong!')
        }
    }

    const handlePrimaryCard = async () => {
        try {
            setPrimaryRequest(true)
            const res = await subscriptionService.makePrimary(data.id)
            if (res.status) {
                setSubscriptionInfo(res.data)
                toast.success(res.message)
                setRefreshKey((e) => e + 1)
            } else toast.error(res.message)
            setPrimaryRequest(false)
        } catch (error) {
            console.log('card error', error)
            toast.error('Something went wrong!')
            setPrimaryRequest(false)
        }
    }

    const renderCardStatusChip = () => {
        if (data.isExpired) {
            return <span className="tw-w-max tw-px-2 tw tw-rounded tw-bg-red-500 tw-border tw-text-white">Expired</span>
        }
        if (data.isExpiredNextMonth) {
            return <span className="tw-w-max tw-px-2 tw-rounded tw-bg-yellow-600 tw-border tw-text-white">EXP. Soon</span>
        } 
        return <span className=" tw-w-max tw-px-2 tw-rounded tw-bg-green-600 tw-border tw-text-white">Active</span>
    }

    return (
        <>
            <div className={selected && selectedStyle != undefined ? selectedStyle : `tw-mb-4 tw-p-4 tw-rounded tw-ring-1 tw-flex tw-gap-y-2 tw-flex-col md:tw-flex-row tw-items-start tw-justify-between tw-text-gray-600 ${selected ? subscriptionInfo?.updatePaymentMethodRequired ? 'tw-ring-red-500' : 'tw-ring-gray-500' : 'tw-ring-gray-500'}`}>
                <div className="tw-flex tw-items-start tw-gap-4 tw-w-full">
                    
                    <div className='tw-flex tw-flex-col tw-w-full tw-gap-2'>
                        <div className='tw-items-center tw-flex tw-flex-row tw-gap-1 tw-justify-between tw-w-full'>

                            <div className=' tw-w-full tw-flex tw-flex-wrap tw-gap-2'>
                                <div className='tw-flex tw-h-full tw-items-start '>
                                    <h4 className="tw-pt-1">
                                        {/* <span className="tw-text-xs tw-capitalize">Credit Card {' '}({data.brand})</span>      */}
                                        <span className="tw-text-xs tw-capitalize">Credit Card</span>     
                                    </h4>
                                </div>
                                <div className='tw-flex tw-flex-1 tw-items-center tw-flex-row tw-gap-2 tw-justify-between'>
                                    {data.id == primaryId && (
                                        <span className={selected && selectedViewStyle != undefined ? selectedViewStyle :  `tw-capitalize tw-bg-blue-500 tw-w-max tw-text-white tw-text-xs tw-p-1 tw-rounded`}>
                                            {selectedText ?? "Primary"}
                                        </span>
                                    )}
                                    {data.id != primaryId && (
                                        <span
                                            onClick={() => {
                                                if(selectedAction != undefined) {
                                                    selectedAction(data.id)
                                                } else {
                                                    handlePrimaryCard()
                                                }
                                            }}
                                            className={selectButtonStyle ?? `tw-py-1 tw-bg-[#AAAAAA] tw-h-fit tw-w-max tw-text-sm tw-px-2 tw-cursor-pointer tw-rounded tw-text-white tw-border`}
                                        >
                                            {primaryRequest ? 'Please wait...' : selectText ?? 'Make Primary'}
                                        </span>
                                    )}
                                    <div className="tw-flex tw-items-center">
                                        {data.id != primaryId && (
                                            <span
                                                onClick={() => setAlert(true)}
                                                className="tw-text-[#FF0000] tw-underline tw-h-fit tw-cursor-pointer"
                                            >
                                                Delete Card
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div className='tw-flex tw-flex-row tw-flex-wrap tw-gap-2'>
                            <img 
                                src={creditCardTypeAsset(data.brand)} 
                                loading="lazy" 
                                className="tw-h-14 tw-w-24 tw-rounded-md" 
                                alt="credit card" 
                            />
                            <div className='tw-flex tw-flex-col tw-justify-between'>
                                <p className="tw-p-0 tw-text-sm">Card number: XXXX-XXXX-XXXX-{data.last4}</p>
                                <div className='tw-flex tw-flex-row tw-gap-2'>
                                    <p className="tw-p-0 tw-text-sm">Expiration Date: {`${String(data.exp_month).padStart(2, '0')}-${data.exp_year}`}</p>
                                </div>
                            </div>
                           
                       </div>
                    </div>
                </div>
            </div>

            {alert && (
                <AlertBox
                    onProceed={handleDelete}
                    onCancle={() => setAlert(false)}
                    message={'Are you sure want to delete this card?'}
                />
            )}
        </>
    )
}


